export const thunkTypes = {
  LIST_BATCHES: `batches/listBatches`,
  GET_INVENTORY: `batches/getInventory`,
  GET_MOVEMENTS_SUMMARY: `batches/getMovementsSummary`,
  GET_HOLDINGS: `batches/getHoldings`,
  DISTRIBUTE: `batches/distribute`,
  GET_RECEPTIONS: `batches/getReceptions`,
  RECORD_RECEPTION: `batches/recordReception`,
  GET_CUSTODY: `batches/getCustody`,
  RECORD_CUSTODY: `batches/recordCustody`,
  CREATE_BATCH: `batches/createBatch`,
  ADVANCE_BATCH: `batches/advanceBatch`,
  RECEIVE_BATCH: `batches/receiveBatch`,
  RECONCILE_BATCH: `batches/reconcileBatch`,
};
